import { AfterViewInit, Component } from '@angular/core';

import { BasePage } from '../../base.page';
import { ParentEvents } from '../../../utils/parent-events.service';

@Component({
    templateUrl: './not-found.page.html',
    styleUrls: ['./not-found.page.scss'],
})
export class NotFoundPage extends BasePage implements AfterViewInit {
    constructor(parentEvents: ParentEvents) {
        super(parentEvents);
    }
}
